/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import SidebarItem from './project-sidebar-item';
import TestTypes from '../../../core/constants/testTypes';
import ParticipantsSource from '../../../core/constants/participantsSource';

import {
  HeaderContainer,
  ItemsContainer,
  Logo,
  LogoContainer,
  Progress,
  ProgressContainer,
  ProgressLabel,
  Sidebar,
  TestType,
  Title,
  TypeProject,
} from './styles';

class ProjectSidebar extends React.Component {
  transformProjectStatus = (status) => {
    if (status === 'in_progress') {
      return 'in progress';
    }

    return status;
  }

  getProjectStatusProgress = (status) => {
    switch (status) {
      case 'draft':
        return 25;

      case 'in_progress':
        return 50;

      case 'done':
        return 100;

      default:
        return 0;
    }
  }

  buildSidebarItemProps = (item) => {
    const { active, project } = this.props;
    const { id } = project;

    const path = `/projects/${id}/${item}`;

    return {
      active: (active === item),
      onSidebarItemClicked: this.onSidebarItemClicked(path),
      dataName: item,
    };
  }

  onSidebarItemClicked = (path) => () => {
    const { history } = this.props;

    history.push(path);
  }

  render() {
    const { project } = this.props;
    const {
      sortType,
      name,
      participantsSource,
      status,
      testType,
    } = project;

    const isModerated = testType === TestTypes.MODERATED;
    const isCardSort = testType === TestTypes.CARD_SORT;
    const isTreeTest = testType === TestTypes.TREE_TEST;
    const isSurvey = testType === TestTypes.SURVEY;
    const isUpload = testType === TestTypes.UPLOAD;

    const formatCardSortType = sortType === 'opened' ? 'Open' : sortType;
    const projectType = testType === 'card_sort' ? `${formatCardSortType} ${testType}` : `${testType}`;

    return (
      <Sidebar visible>
        <LogoContainer>
          <Link to="/">
            <Logo src="/images/playbook-logo.png" alt="Playbook" />
          </Link>
        </LogoContainer>
        <HeaderContainer>
          <TypeProject>
            <Title
              text={name}
              lines={2}
              ellipsis="..."
              buttons={false}
            />

            <TestType>{_.startCase(projectType)}</TestType>
          </TypeProject>

          <ProgressContainer>
            <Progress
              data-sidebar-status={status}
              percent={this.getProjectStatusProgress(status)}
              size="tiny"
            />
            <ProgressLabel>{this.transformProjectStatus(status)}</ProgressLabel>
          </ProgressContainer>
        </HeaderContainer>

        <ItemsContainer>
          <SidebarItem
            {...this.buildSidebarItemProps('study')}
            key="sidebar-item-study"
            label="Study"
            image="sidebar-study.svg"
            imageSelected="sidebar-study-selected.svg"
          />

          {isModerated && (
            <SidebarItem
              {...this.buildSidebarItemProps('schedule')}
              key="sidebar-item-schedule"
              label="Schedule"
              image="sidebar-schedule.svg"
              imageSelected="sidebar-schedule-selected.svg"
            />
          )}

          <SidebarItem
            {...this.buildSidebarItemProps('participants')}
            key="sidebar-item-participants"
            label="Participants"
            image="sidebar-participants.svg"
            imageSelected="sidebar-participants-selected.svg"
          />

          {!(isCardSort || isTreeTest || isSurvey || isUpload || (isModerated && participantsSource === ParticipantsSource.COMPANY)) && (
            <SidebarItem
              {...this.buildSidebarItemProps('analytics')}
              key="sidebar-item-analytics"
              label="Analytics"
              image="sidebar-analytics.svg"
              imageSelected="sidebar-analytics-selected.svg"
            />
          )}

          {isCardSort && (
            <SidebarItem
              {...this.buildSidebarItemProps('analytics-card-sort')}
              key="sidebar-item-analytics-card-sort"
              label="Analytics"
              image="sidebar-analytics.svg"
              imageSelected="sidebar-analytics-selected.svg"
            />
          )}

          {isTreeTest && (
            <SidebarItem
              {...this.buildSidebarItemProps('analytics-tree-test')}
              key="sidebar-item-analytics-tree-test"
              label="Analytics"
              image="sidebar-analytics.svg"
              imageSelected="sidebar-analytics-selected.svg"
            />
          )}

          {isSurvey && (
            <SidebarItem
              {...this.buildSidebarItemProps('analytics-survey')}
              key="sidebar-item-analytics-survey"
              label="Analytics"
              image="sidebar-analytics.svg"
              imageSelected="sidebar-analytics-selected.svg"
            />
          )}

          <SidebarItem
            {...this.buildSidebarItemProps('reports')}
            key="sidebar-item-reports"
            label="Reports"
            image="sidebar-reports.svg"
            imageSelected="sidebar-reports-selected.svg"
          />
        </ItemsContainer>
      </Sidebar>
    );
  }
}

ProjectSidebar.propTypes = {
  active: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

export default withRouter(ProjectSidebar);
